import script from "./TownHomeLevel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TownHomeLevel.vue?vue&type=script&setup=true&lang=ts"

import "./TownHomeLevel.vue?vue&type=style&index=0&id=7122ee5d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7122ee5d"]])

export default __exports__